import styles from './ChallengeHeader.module.css';

type ChallengeHeaderProps = {
  brandName: string;
};

export default function ChallengeHeader({ brandName }: ChallengeHeaderProps) {
  return (
    <header className={styles.header}>
      <p className={styles.brandName}>{brandName}</p>
    </header>
  );
}
